import { render, staticRenderFns } from "./mySpirit.vue?vue&type=template&id=acf04240&scoped=true"
import script from "./mySpirit.vue?vue&type=script&lang=js"
export * from "./mySpirit.vue?vue&type=script&lang=js"
import style0 from "./mySpirit.vue?vue&type=style&index=0&id=acf04240&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf04240",
  null
  
)

export default component.exports